module.exports = __webpack_public_path__ + "img/ZMW.463fe68c.svg";